import { render } from "./ScreeningResults.component.vue?vue&type=template&id=3697f4d0"
import script from "./ScreeningResults.component.vue?vue&type=script&lang=js"
export * from "./ScreeningResults.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/screening/ScreeningResults.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3697f4d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3697f4d0', __exports__)) {
    console.log('reload')
    api.reload('3697f4d0', __exports__)
  }
  
  module.hot.accept("./ScreeningResults.component.vue?vue&type=template&id=3697f4d0", () => {
    console.log('re-render')
    api.rerender('3697f4d0', render)
  })

}


export default __exports__